import { BaseConnection } from '@app/utilities/foblex-flow/base-connection';
import {NodeConnection as _NodeConnection} from '../../../shared-models/public/node-connection';

export class NodeConnection extends _NodeConnection{
    public toBaseConnection(): BaseConnection<NodeConnection.ServerSideMeta> {
        return new BaseConnection<NodeConnection.ServerSideMeta>(
            this.from,
            this.to,
            this.id,
            {
                siteId: this.siteId,
                createdAt: this.createdAt
            }
        );
    }

    static fromBaseConnection<T>(baseConnection: BaseConnection<T>): NodeConnection {
        const connection = new NodeConnection();
        connection.from = baseConnection.from;
        connection.to = baseConnection.to;
        connection.id = baseConnection.id;
        connection.siteId = (baseConnection.meta as NodeConnection.ServerSideMeta).siteId;
        connection.createdAt = (baseConnection.meta as NodeConnection.ServerSideMeta).createdAt;
        return connection;
    }
}

export namespace NodeConnection{
    export type ServerSideMeta = Pick<NodeConnection, 'siteId' | 'createdAt'>;
    export import RestTypes=_NodeConnection.RestTypes;
}